import { useEffect, useState } from 'react';
import { FiMoreVertical } from 'react-icons/fi';
import styles from './ActionMenu.module.css';

const ActionMenu = ({ items, ariaLabel = 'Actions' }) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!open) return;
        const closeMenu = () => setOpen(false);
        document.addEventListener('click', closeMenu);
        return () => document.removeEventListener('click', closeMenu);
    }, [open]);

    return (
        <>
            <button
                type="button"
                className={styles.kebabButton}
                aria-label={ariaLabel}
                onClick={(event) => {
                    event.stopPropagation();
                    setOpen((prev) => !prev);
                }}
            >
                <FiMoreVertical size={18} />
            </button>

            {open && (
                <div className={`${styles.menu} text-start`}>
                    {items.map(({ label, danger, onClick }) => (
                        <button
                            key={label}
                            type="button"
                            className={danger ? styles.dangerAction : ''}
                            onClick={() => {
                                setOpen(false);
                                onClick();
                            }}
                        >
                            {label}
                        </button>
                    ))}
                </div>
            )}
        </>
    );
};

export default ActionMenu;
